import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { useModal } from 'context/ModalContext';
import { actionLog } from 'services/actionlog.service';

import { ConfirmacaoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
  playerInfo?: any;
}

export default function ModalParticipantsReject({ callback, id, data, playerInfo }: Props) {
  const modalID = 'validation-participants-reject';

  const { openModal, closeModal } = useModal();

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);

  async function registerLog() {
    if (sending) return false;

    setSending(true);

    try {
      await actionLog('me', 'task_participants_approval', {
        taskId: id,
        approved: false,
        quantity: data?.team?.length,
      });

      setSending(false);
      document.dispatchEvent(new CustomEvent('reload:pendingapproval'));
      callback({ id: 'reload_task' });
      closeModal();

      toast.success(`Avaliação realizada com sucesso.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      toast.error(`Ocorreu um erro ao registrar sua ação. Por favor, tente novamente em alguns minutos.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setSending(false);
    }
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <ConfirmacaoDaAcao
      title="Autorizar número de participantes na realização"
      onClose={() => (!sending ? closeModal() : null)}
      backDisabled={sending}
      onConfirm={() => {
        registerLog();
      }}
      confirmDisabled={sending}
    >
      <p className="m-0">Você pode não autorizar o número de participantes na realização. Deseja confirmar essa ação?</p>
    </ConfirmacaoDaAcao>
  );
}
